import * as types from './PlanEditorOrdersActionTypes';
import Api from '../PlanEditorOrdersApi';
import AnnotationApi from '../../planannotation/PlanAnnotationsApi';
import SharedApi from '../../../components/common/planOrder/SharedApi';
import { IPlanOrder, IFile } from '../Entities';

export function resetList() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        dispatch({ type: types.RESET_PLAN_EDITOR_ORDERS_LIST });
}

function getPlanOrdersSuccess(planOrders: IPlanOrder[]) {
    return { type: types.GET_PLAN_EDITOR_ORDERS_SUCCESS, result: planOrders };
}

export function getPlanOrders() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.getPlanOrders().then((planOrders: IPlanOrder[]) => {
            dispatch(getPlanOrdersSuccess(planOrders));
        });
}

function grabPlanOrderSuccess(result: any) {
    return { type: types.GRAB_PLAN_ORDER_SUCCESS, result: result };
}

export function grabPlanOrder(planOrderId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.grabPlanOrder(planOrderId).then((result: any) => {
            dispatch(grabPlanOrderSuccess(result));
        });
}

function editPlanOrderSuccess(result: any) {
    return { type: types.EDIT_PLAN_EDITOR_ORDER_SUCCESS, result: result };
}

export function editPlanOrder(planOrderId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.editPlanOrder(planOrderId).then((result: any) => {
            dispatch(editPlanOrderSuccess(result));
        });
}

function getCompareDataSuccess(result: any) {
    return { type: types.GET_PLAN_EDITOR_COMPARE_DATA_SUCCESS, result: result };
}

export function getCompareData(planOrderId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        SharedApi.getCompareData(planOrderId).then((result: any) => {
            dispatch(getCompareDataSuccess(result));
        });
}

function addPlanOrderExternalFileSuccess(result: any, category: number) {
    const externalDeliveryFileValue = 1;
    const internalExternalFileValue = 2;

    if (category === externalDeliveryFileValue) {
        return {
            type: types.ADD_PLAN_ORDER_EXTERNAL_DELIVERY_FILE_SUCCESS,
            result: result
        };
    } else if (category === internalExternalFileValue) {
        return {
            type: types.ADD_PLAN_ORDER_INTERNAL_EXTERNAL_FILE_SUCCESS,
            result: result
        };
    }
}

export function addPlanOrderExternalFile(
    id: number,
    planOrderId: number,
    fileInfoId: number,
    filename: string,
    fileReference: string,
    fileType: string,
    thumbnailReference: string,
    oldFileId: number,
    category: number
) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) => {
        dispatch(
            addPlanOrderExternalFileSuccess(
                {
                    id: id,
                    planOrderId: planOrderId,
                    fileInfoId: fileInfoId,
                    filename: filename,
                    fileReference: fileReference,
                    fileType: fileType,
                    thumbnailReference: thumbnailReference,
                    oldFileId: oldFileId
                },
                category
            )
        );
    };
}

function deletePlanOrderExternalFileSuccess(result: any) {
    const externalDeliveryFileValue = 1;
    const internalExternalFileValue = 2;

    if (result.category === externalDeliveryFileValue) {
        return {
            type: types.DELETE_PLAN_ORDER_EXTERNAL_DELIVERY_FILE_SUCCESS,
            result: result
        };
    } else if (result.category === internalExternalFileValue) {
        return {
            type: types.DELETE_PLAN_ORDER_INTERNAL_EXTERNAL_FILE_SUCCESS,
            result: result
        };
    }
}

export function deletePlanOrderExternalFile(planOrderId: number, fileInfoId: number) {
    return (dispatch: (result: any) => void) =>
        Api.deletePlanOrderExternalFile(planOrderId, fileInfoId).then((result: any) => {
            dispatch(deletePlanOrderExternalFileSuccess(result));
        });
}

function addPlanOrderStoreyExternalFileSuccess(result: any) {
    return {
        type: types.ADD_PLAN_ORDER_STOREY_EXTERNAL_FILE_SUCCESS,
        result: result
    };
}

export function addPlanOrderStoreyExternalFile(
    planOrderStoreyId: number,
    fileInfoId: number,
    filename: string,
    fileReference: string,
    fileType: string,
    thumbnailReference: string,
    oldFileInfoId?: number,
    oldFileReference?: string
) {
    return (dispatch: (result: any) => void) => {
        dispatch(
            addPlanOrderStoreyExternalFileSuccess({
                planOrderStoreyId: planOrderStoreyId,
                fileInfoId: fileInfoId,
                filename: filename,
                fileReference: fileReference,
                fileType: fileType,
                thumbnailReference: thumbnailReference,
                oldFileInfoId: oldFileInfoId,
                oldFileReference: oldFileReference
            })
        );
    };
}

function deletePlanOrderStoreyExternalFileSuccess(result: any) {
    return {
        type: types.DELETE_PLAN_ORDER_STOREY_EXTERNAL_FILE_SUCCESS,
        result: result
    };
}

export function deletePlanOrderStoreyExternalFile(
    planOrderId: number,
    planOrderStoreyId: number,
    fileInfoId: number
) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.deletePlanOrderStoreyExternalFile(planOrderId, planOrderStoreyId, fileInfoId).then(
            (result: any) => {
                dispatch(deletePlanOrderStoreyExternalFileSuccess(result));
            }
        );
}

function addPlanOrderStorey2DFileSuccess(result: any) {
    return {
        type: types.ADD_PLAN_ORDER_STOREY_2D_FILE_SUCCESS,
        result: result
    };
}

export function addPlanOrderStorey2DFile(planOrderStoreyId: number, result: IFile) {
    return (dispatch: (result: any) => void) => {
        dispatch(
            addPlanOrderStorey2DFileSuccess({
                planOrderStoreyId: planOrderStoreyId,
                file: result
            })
        );
    };
}

function addPlanOrderStorey3DFileSuccess(result: any) {
    return {
        type: types.ADD_PLAN_ORDER_STOREY_3D_FILE_SUCCESS,
        result: result
    };
}

export function addPlanOrderStorey3DFile(planOrderStoreyId: number, result: IFile) {
    return (dispatch: (result: any) => void) => {
        dispatch(
            addPlanOrderStorey3DFileSuccess({
                planOrderStoreyId: planOrderStoreyId,
                file: result
            })
        );
    };
}

function approvePlanOrderSuccess(result: any) {
    return { type: types.APPROVE_PLAN_ORDER_SUCCESS, result: result };
}

export function approvePlanOrder(planOrderId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.approvePlanOrder(planOrderId).then((result: any) => {
            dispatch(
                approvePlanOrderSuccess({
                    status: result,
                    planOrderId: planOrderId
                })
            );
        });
}

function generateFilesSuccess(result: any) {
    return { type: types.GENERATE_FILES_PLAN_ORDER_SUCCESS, result: result };
}

export function generateFiles(planOrderId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.generateFiles(planOrderId).then((result: any) => {
            dispatch(generateFilesSuccess(result));
            return result;
        });
}

function downloadFilesSuccess(result: any) {
    return { type: types.DOWNLOAD_FILES_PLAN_ORDER_SUCCESS, result: result };
}

export function downloadFiles(planOrderId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.downloadFiles(planOrderId).then((result: any) => {
            dispatch(downloadFilesSuccess(result));
        });
}

function editAnnotationSucceeded(result: any): any {
    return { type: types.EDITOR_EDIT_PLAN_ANNOTATION_SUCCESS, result: result };
}

export function editAnnotation(planOrderStoreyFileId: number, planAnnotationType: string): any {
    return (dispatch: any, getState: any) =>
        AnnotationApi.editAnnotation(planOrderStoreyFileId, planAnnotationType).then(
            (result: any) => {
                dispatch(editAnnotationSucceeded(result));
                return result;
            }
        );
}

export function saveAnnotationTexts(planOrderFileRevisionId: number, data: string): any {
    return () => AnnotationApi.saveAnnotationTexts(planOrderFileRevisionId, data);
}

export function updatePlacements(planOrderId: number, files: any[], planOrderStoreyFileId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        AnnotationApi.updatePlacements(planOrderId, files, planOrderStoreyFileId);
}

function updatePlanEditorSucceeded(planEditorId: any): any {
    return {
        type: types.PLAN_EDITOR_UPDATE_PLAN_EDITOR_SUCCESS,
        result: planEditorId
    };
}

export function updatePlanEditor(
    planOrderId: number,
    planEditorId: number,
    dontRemoveFromList: boolean
): any {
    return (dispatch: any, getState: any) =>
        Api.updatePlanEditor(planOrderId, planEditorId).then((result: any) => {
            dispatch(
                updatePlanEditorSucceeded({
                    planOrderId: planOrderId,
                    planEditorId: result.planEditorId,
                    planEditor: result.planEditor,
                    dontRemoveFromList: dontRemoveFromList
                })
            );
        });
}

function createStoreySuccess(storey: any) {
    return { type: types.ADD_PLAN_EDITOR_STOREY_SUCCESS, result: storey };
}

export function createEmptyStorey(planOrderId: number) {
    return (dispatch: (result: any) => void) =>
        Api.createEmptyStorey(planOrderId).then((result: any) => {
            dispatch(createStoreySuccess(result));
        });
}

export function createStorey(storey: any) {
    return (dispatch: (storey: any) => void, getState: (error: any) => void) =>
        dispatch(createStoreySuccess(storey));
}

function updatePlanOrderStoreySortSuccess(result: any) {
    return {
        type: types.UPDATE_EDITOR_PLAN_ORDER_STOREY_SORT_SUCCESS,
        result: result
    };
}

export function updatePlanOrderStoreySort(planOrderId: number, storey: any) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.updatePlanOrderStoreySort(planOrderId, storey).then((result: any) => {
            dispatch(updatePlanOrderStoreySortSuccess(result));
        });
}

function deleteStoreySuccess(result: any) {
    return { type: types.DELETE_EDITOR_STOREY_SUCCESS, result: result };
}

export function deleteStorey(planOrder: number, storeyId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.deleteStorey(planOrder, storeyId).then((result: any) => {
            dispatch(deleteStoreySuccess(result));
        });
}

function updatePlanOrderSuccess(result: any) {
    return { type: types.UPDATE_EDITOR_PLAN_ORDER_SUCCESS, result: result };
}

export function updatePlanOrder(planOrderId: number, planOrderStoreyId: any, data: any) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.updateStorey(planOrderId, planOrderStoreyId, data).then((result: any) => {
            dispatch(updatePlanOrderSuccess(result));
        });
}

function deleteDeliveryFileSuccess(reference: any) {
    return {
        type: types.EDITOR_DELETE_DELIVERY_FILE_SUCCESS,
        result: reference
    };
}

export function deleteDeliveryFile(reference: string) {
    return (dispatch: (result: any) => void) =>
        Api.deleteDeliveryFile(reference).then((result: any) => {
            dispatch(deleteDeliveryFileSuccess(reference));
        });
}
